module.exports = __webpack_public_path__ + "static/media/explore-image-5.bf7a171c.jpg";